@if (available) {
    @if (!widget.hidden() && !widget.opened() && !dialogClosing()) {
        <div class="help-launcher" [style.visibility]="obstructed() ? 'hidden' : 'visible'">
            <button type="button" class="help-dismiss" aria-label="Ocultar ayuda flotante" title="Ocultar ayuda" (click)="widget.dismiss()"><i class="pi pi-times" aria-hidden="true"></i></button>
            <button type="button" class="help-open" aria-label="Abrir centro de ayuda flotante" title="Centro de ayuda" (click)="widget.show()" aria-haspopup="dialog"><i class="pi pi-comments" aria-hidden="true"></i><span>Ayuda</span></button>
        </div>
    }
}
<p-dialog
    header="Centro de ayuda · Calfrac + Blister"
    [visible]="dialogVisible()"
    (visibleChange)="widget.opened.set($event)"
    (onHide)="dialogClosing.set(false)"
    [modal]="false"
    [draggable]="false"
    [resizable]="false"
    position="bottomright"
    [style]="{ width: '680px', maxWidth: 'calc(100vw - 1rem)', maxHeight: 'min(780px, calc(100dvh - 2rem))', margin: '0.5rem' }"
    [contentStyle]="{ padding: '0', overflow: 'auto' }"
    styleClass="sigd-help-window"
>
    @if (available) {
        @defer (when widget.opened()) {
            <app-faq [embedded]="true" />
        }
    }
    <ng-template pTemplate="footer">
        <span class="window-hint">Podés cerrar esta ventana y seguir en tu pantalla.</span>
        <button type="button" class="window-hide" (click)="widget.dismiss()">Ocultar ayuda</button>
    </ng-template>
</p-dialog>
